export default {
    page_title: "Tarefas",
    add_button: "Adicionar",
    created_tasks: "Tarefas Criadas",
    completed_tasks: "Tarefas Concluídas",
    on_time_tasks: "Concluídas no Prazo",
    conversions: "Conversões",
    conversion_rate: "Taxa de Conversão",
    incentivized_revenue: "Faturamento Incentivado",
    by_user: "Por Usuário",
    by_automation: "Por Automação",
    name: "Nome",
    created: "Criadas",
    completed: "Concluídas",
    on_time: "Concluídas no Prazo",
    no_data_for_period: "Sem dados para o período",
    automation_filter: "Automação",
    task_due_date: "Prazo da tarefa",
    created_date: "Data de criação",
    completed_date: "Data de conclusão",
};
